// @flow
import { connect } from 'react-redux';
import {
  compose,
  withHandlers,
  lifecycle,
  branch,
  renderNothing,
} from 'recompose';
import { reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import PrivacyModal from './PrivacyModal';
import * as signals from '../../../application/signals';
import * as r from 'ramda';

const valueSelector = formValueSelector('privacyRibbon');

const mapStateToProps = (state) => {
  return {
    expanded: valueSelector(state, 'expanded'),
    cookies: [
      {
        name: 'analytics',
        optOut: true,
      },
      {
        name: 'marketing',
        optOut: true,
      },
      {
        name: 'support',
        optOut: true,
      },
      {
        name: 'essential',
        optOut: false,
      },
    ],
    initialValues: {
      expanded: false,
      analytics: true,
      marketing: true,
      support: true,
    },
    open: window.utag.data['cp.pwinteraction'] !== 'yes',
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  submitForm: signals.submitForm,
}, dispatch);

export const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    r.propEq('open', false),
    renderNothing,
    compose(
      withHandlers({
        onSubmit: ({ submitForm }) => (values) => new Promise((resolve, reject) => {
          submitForm(values, 'modal');
        }),
      }),
      reduxForm({
        form: 'privacyRibbon',
        propNamespace: 'form',
      }),
      lifecycle({
        componentDidMount: function() {
          this.props.form.change('__ready__', true);
        },
      }),
    ),
  ),
);

export default enhance(PrivacyModal);



// WEBPACK FOOTER //
// ./src/presentation/components/privacy-modal/ConnectedPrivacyModal.js